import { Link } from "react-router-dom";
import { useArticles } from "../../../hooks/useArticles";
import { toNewsItems } from "../../../lib/articleAdapter";
import NewsCard from "./NewsCard";

export default function InterviewsSection() {
  const { articles, loading } = useArticles("Entrevista");
  const interviews = toNewsItems(articles).slice(0, 2);

  if (loading) {
    return (
      <section className="bg-white py-6 md:py-12">
        <div className="max-w-screen-xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-4 mb-4 md:mb-8">
            <div className="w-11 h-11 rounded-xl bg-slate-200 animate-pulse" />
            <div className="h-8 bg-slate-200 rounded w-48 animate-pulse" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            <div className="h-96 bg-slate-100 rounded-2xl animate-pulse" />
            <div className="h-96 bg-slate-100 rounded-2xl animate-pulse" />
          </div>
        </div>
      </section>
    );
  }

  if (interviews.length === 0) {
    return null;
  }

  return (
    <section className="bg-[#FDF8F8] py-6 md:py-12 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
        <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full border border-rose-600" />
        <div className="absolute top-10 left-10 w-48 h-48 rounded-full border border-rose-500" />
      </div>

      <div className="max-w-screen-xl mx-auto px-4 md:px-6 relative z-10">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-4 md:mb-8">
          <div className="flex items-center gap-4">
            <div className="w-11 h-11 flex items-center justify-center bg-rose-600 rounded-xl">
              <i className="ri-mic-line text-white text-xl" />
            </div>
            <div>
              <span
                className="text-rose-600 text-xs font-bold tracking-widest uppercase"
                style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
              >
                En exclusiva
              </span>
              <h2
                className="text-[#0B1F3A] font-extrabold leading-tight"
                style={{ fontFamily: "'Sora', sans-serif", fontSize: "1.9rem" }}
              >
                Entrevistas
              </h2>
              <p
                className="text-slate-400 text-sm mt-0.5 hidden sm:block"
                style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
              >
                Conversaciones con los protagonistas del sector aeronáutico
              </p>
            </div>
          </div>
          <Link
            to="/actualidad?categoria=Entrevista"
            className="flex-shrink-0 flex items-center gap-2 px-5 py-2.5 border border-rose-300 hover:border-rose-400 text-rose-600 hover:text-rose-700 rounded-xl text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            Ver todas las entrevistas <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Cards Grid — 2 columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {interviews.map((item) => (
            <NewsCard key={item.id} item={item} variant="default" />
          ))}
        </div>
      </div>
    </section>
  );
}